import { useEffect, useRef, useState } from "react";
import { DronerListCard } from "./DronerCard";
import { Box, Button, Skeleton } from "@mui/material";
import { DetailedSearchPage } from "../types/cmsLocalizationTypes";
import CloseIcon from "@mui/icons-material/Close";

export function DetailedSearchLargeView({
  selectedDroners,
  setSelectedDroners,
  localizedPageContent,
}: {
  selectedDroners: any[];
  setSelectedDroners: any;
  localizedPageContent: DetailedSearchPage;
}) {
  const [open, setOpen] = useState(false);
  const sideNav = useRef<any>(null);
  const sideNavWidth = "350px";
  useEffect(() => {
    const main = document?.getElementById("maps");
    if (open) {
      sideNav.current.style.width = sideNavWidth;
      main!.style.marginLeft = sideNavWidth;
    } else {
      sideNav.current.style.width = "0";
      main!.style.marginLeft = "0px";
    }
    return () => {
      main!.style.marginLeft = "0px";
    };
  }, [open]);

  useEffect(() => {
    if (selectedDroners.length > 0) {
      setOpen(true);
    }
  }, [selectedDroners]);

  return (
    <div className="relative h-full " style={{ width: 0 }}>
      <div id="mySidenav" ref={sideNav} className="sidenav bg-background">
        <div className="flex col gap-normal p-normal">
          <div className="mt-extra mb-large">
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <h3 className="text-text">
                {localizedPageContent.dronersListTitle}
              </h3>
              {open && (
                <Button
                  sx={{
                    px: 0,
                    mr: "-25px",
                    color: "#4f4f4f",
                  }}
                  onClick={() => {
                    setOpen(!open);
                    setSelectedDroners([]);
                  }}
                >
                  <CloseIcon />
                </Button>
              )}
            </Box>
            {selectedDroners?.length ? (
              <p className="text-text">
                {selectedDroners.length} {localizedPageContent.searchResultText}
              </p>
            ) : (
              <p className="text-text">
                {localizedPageContent.searchLoadingText}
              </p>
            )}
          </div>
          {selectedDroners?.length
            ? selectedDroners?.map((item: any, i: number) => (
                <DronerListCard key={i} droner={item} />
              ))
            : [...Array(40)].map((item, i) => (
                <Skeleton
                  className="rounded-all-normal"
                  variant="rectangular"
                  key={i}
                  width="100%"
                  height={118}
                />
              ))}
        </div>
      </div>
    </div>
  );
}
